import styled from "styled-components";
export const ButtonPrimary = styled.button`
    background-color:#fff;
    color: #3e3e3e;
    padding: 5px 8px;
    border: 1px solid #ffc107
    border-radius:4px;
    cursor: pointer;
    font-size:14px;
    :hover{
        background-color:#0d6efd;
        color:#fff;
    }
`;